import React, { memo, useEffect } from 'react';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';

import { changeGenieProjectAccessAssistants, changeProject, getProject } from '../../../redux/projects/projectsActions';
import { resetEditProjectPage } from '../../../redux/projects/projectsReducer';
import NameSection from '../name/NameSection';
import ShareSection from '../share/ShareSection';
import AccessUsersSection from '../access-users/AccessUsersSection';
import { getGenieBrandOptions } from '../../../redux/genie/genieActions';
import AssignedAssistantsSection from '../edit-genie/components/assignedAssistants/AssignedAssistantsSection';
import { PROJECT_TYPES } from '../../../constants';

import scss from './EditGenieGo.module.scss';

const EditGenieGo = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const handleSaveNameSection = ({ id, editProject, values }) => {
    const { projectName, brand, description, referenceMessages } = values;

    dispatch(
      changeProject({
        id,
        projectType: editProject.projectType,
        values: { projectName, brand, description, referenceMessages },
      }),
    );
  };

  const handleChangeAccessAssistants = ({ id, activeAllAssistants }) => {
    dispatch(
      changeGenieProjectAccessAssistants({
        id,
        activeAllAssistants,
        projectType: PROJECT_TYPES.GENIE_GO,
      }),
    );
  };

  useEffect(() => {
    dispatch(getProject({ id }));
    dispatch(getGenieBrandOptions());

    return () => {
      dispatch(resetEditProjectPage());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={scss.pageWrapper}>
      <NameSection onSubmit={handleSaveNameSection} />
      <ShareSection />
      <AssignedAssistantsSection onChangeAccessAssistants={handleChangeAccessAssistants} />
      <AccessUsersSection />
    </div>
  );
};

export default memo(EditGenieGo);
